import { Component, OnInit } from '@angular/core';
import {TechnicalApplicationCategoryModel} from '../../api/technical-application-category-model';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-technical-application-category-selection',
  templateUrl: './technical-application-category-selection.component.html',
  styleUrls: ['./technical-application-category-selection.component.scss']
})
export class TechnicalApplicationCategorySelectionComponent implements OnInit {
  list: TechnicalApplicationCategoryModel[];

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit() {
  }

  onSelect($event: any) {
    this.activeModal.close($event.data);
  }
}
